"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalTieDirectionRule = exports.TieEndpointRank = void 0;
const signal_name_normalization_1 = require("../DataScience/signal-hygiene/signal-name-normalization");
const signal_tie_types_1 = require("./signal-tie-types");
var TieEndpointRank;
(function (TieEndpointRank) {
    TieEndpointRank["MainGround"] = "main_ground";
    TieEndpointRank["Ground"] = "ground";
    TieEndpointRank["Supply"] = "supply";
    TieEndpointRank["Other"] = "other";
})(TieEndpointRank || (exports.TieEndpointRank = TieEndpointRank = {}));
const RANK_ORDER = [
    TieEndpointRank.MainGround,
    TieEndpointRank.Ground,
    TieEndpointRank.Supply,
    TieEndpointRank.Other,
];
const MAIN_GROUND_NAMES = ['gnd', 'vss'];
const SYMBOL_ORDER = ['+', '-'];
class SignalTieDirectionRule {
    constructor(roster) {
        this.rankByName = new Map();
        const mainGroundName = SignalTieDirectionRule.mainGroundNameOf(roster.filter((signal) => signal.ground));
        for (const signal of roster) {
            const name = (0, signal_name_normalization_1.normalizeSignalNameForComparison)(signal.signalName);
            this.rankByName.set(name, name === mainGroundName ? TieEndpointRank.MainGround
                : signal.ground ? TieEndpointRank.Ground
                    : signal.power ? TieEndpointRank.Supply
                        : TieEndpointRank.Other);
        }
    }
    rankOf(signalName) {
        return this.rankByName.get((0, signal_name_normalization_1.normalizeSignalNameForComparison)(signalName)) ?? TieEndpointRank.Other;
    }
    orient(first, second) {
        const firstRank = RANK_ORDER.indexOf(this.rankOf(first));
        const secondRank = RANK_ORDER.indexOf(this.rankOf(second));
        const firstIsTarget = firstRank === secondRank ? SignalTieDirectionRule.compareNames(first, second) > 0 : firstRank < secondRank;
        return firstIsTarget ? { signalName: second, toSignalName: first } : { signalName: first, toSignalName: second };
    }
    orientEnds(record) {
        const ends = this.orient(record.signalName, record.toSignalName);
        return {
            ...record,
            ...ends,
            ...SignalTieDirectionRule.polarityAfterOrienting(record, ends.signalName !== record.signalName),
        };
    }
    canonicalize(signalTies) {
        const tiesByCarrier = new Map();
        for (const signal of signalTies) {
            for (const tie of signal.ties) {
                const ends = this.orient(signal.signalName, tie.toSignalName);
                const ties = tiesByCarrier.get(ends.signalName) ?? [];
                ties.push({
                    ...tie,
                    toSignalName: ends.toSignalName,
                    ...SignalTieDirectionRule.polarityAfterOrienting(tie, ends.signalName !== signal.signalName),
                });
                tiesByCarrier.set(ends.signalName, ties);
            }
        }
        return [...tiesByCarrier.entries()].map(([signalName, ties]) => ({ signalName, ties }));
    }
    static polarityAfterOrienting(tie, swapped) {
        return swapped && tie.polarity !== undefined && tie.polarity !== '' ?
            { polarity: (0, signal_tie_types_1.reverseSignalTiePolarity)(tie.polarity) }
            : {};
    }
    static compareNames(a, b) {
        const left = (0, signal_name_normalization_1.normalizeSignalNameForComparison)(a);
        const right = (0, signal_name_normalization_1.normalizeSignalNameForComparison)(b);
        const shared = Math.min(left.length, right.length);
        for (let index = 0; index < shared; index++) {
            const order = SignalTieDirectionRule.compareCharacters(left[index], right[index]);
            if (order !== 0) {
                return order;
            }
        }
        return left.length - right.length;
    }
    static compareCharacters(a, b) {
        const byClass = SignalTieDirectionRule.characterClass(a) - SignalTieDirectionRule.characterClass(b);
        if (byClass !== 0) {
            return byClass;
        }
        const bySymbol = SignalTieDirectionRule.symbolOrder(a) - SignalTieDirectionRule.symbolOrder(b);
        return bySymbol !== 0 ? bySymbol : (a.codePointAt(0) ?? 0) - (b.codePointAt(0) ?? 0);
    }
    static characterClass(character) {
        if (/\p{Nd}/u.test(character)) {
            return 1;
        }
        if (/\p{L}/u.test(character)) {
            return 2;
        }
        return 0;
    }
    static symbolOrder(character) {
        const index = SYMBOL_ORDER.indexOf(character);
        return index === -1 ? SYMBOL_ORDER.length : index;
    }
    static mainGroundNameOf(grounds) {
        const names = new Set(grounds.map((ground) => (0, signal_name_normalization_1.normalizeSignalNameForComparison)(ground.signalName)));
        if (names.size === 1) {
            return [...names][0];
        }
        return MAIN_GROUND_NAMES.find((name) => names.has(name));
    }
}
exports.SignalTieDirectionRule = SignalTieDirectionRule;
//# sourceMappingURL=signal-tie-direction-rule.js.map